//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { DATE_FORMAT } from "@Shared/@Utils/constants";
import moment from "moment";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CustomList",
  props: {
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    colSize: {
      type: String,
      default: "8"
    },
    additionalElement: {
      type: Boolean,
      default: false
    },
    additionalElementType: {
      type: String,
      default: ""
    }
  },
  computed: {
    optionsList() {
      const clients = this.value.split(",");
      clients.forEach((element, index, arr) => {
        arr[index] = {
          clientName: element,
          id: index
        };
      });
      return clients;
    },
    disabled() {
      return this.additionalElementType === "signature";
    },
    additionalElementComponents() {
      const newDate = new Date();
      const currentDate = moment(newDate).local().format(DATE_FORMAT);
      const elements = {
        signature: {
          label: "Signature",
          value: ""
        },
        currentDate: {
          label: "Current Date",
          value: currentDate
        }
      };
      return elements[this.additionalElementType];
    }
  }
});